import storeActionsController from '~/utils/voicerconfig/store-actions'

export default function (context) {
  return storeActionsController({
    route: context.route,
    store: context.store,
  })
}
